import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { requestPasswordReset } from '../../api/api';
import { toast } from 'react-toastify';

function RequestPasswordResetModal({ show, setShow }) {
    const [email, setEmail] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        requestPasswordReset(email).then(() => {
            setShow(false);
            toast.success(`Password Reset Email sent to ${email}`);
        });
    };

    return (
        <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Request Password Reset</Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="requestPasswordReset.Email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" onChange={(e) => setEmail(e.target.value)} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="ms-auto" onClick={() => setShow(false)}>Cancel</Button>
                    <Button variant="primary" type="submit" onClick={handleSubmit}>Submit</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default RequestPasswordResetModal;